<!-- Mobile menu navigation -->
<air-navigation
  *ngIf="mobileMenuLinks.length > 0"
  [name]="'mobile'"
  [navigationItems]="mobileMenuLinks"
  [navClass]="'d--none d--block--sm'"
  [@sheetUp]="animationState"
  [showBackdrop]="true"
  [userEventSource]="userEventSource"
></air-navigation>
